/* eslint-disable no-unused-vars */
/* eslint-disable function-paren-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import InfoIconImg from 'src/assets/benefits-important.svg';
import BenefitsCart, { ReactComponent as BenefitsCartIcon } from 'src/assets/benefits-cart.svg';
import { ReactComponent as BenefitsAvailableIcon } from 'src/assets/benefits-available.svg';

import { FullScreenLoading } from 'pg-ui-library';
import { useTypedSelector } from 'src/hooks/useTypedSelector';

import { useActions } from 'src/hooks/useActions';
import { monetaryUSDFormat } from 'src/utils/currencyFormat';

import {
  Container,
  Header,
  HeaderTitle,
  Content,
  HeaderItemLeft,
  HeaderItemRight,
  CancelButton,
  InfoIconContainer,
  InfoIcon,
  TooltipText,
  RelativeContainer,
  ScrollableContainer,
  ScrollableContainerEmpty,
  CartFooter,
  CartFooterText,
  CartContainer,
  LeftGridContent,
  RightGridContent,
} from './styles';
import AvailableBenefitsCard from '../available-benefits-card';
import EnrollmentChanges from '../enrollment-changes';
import CartTabs from '../cart-tabs';

import { EnrollSelectionModal } from '../enroll-selection-modal';
import { StoreContextProvider, useBenefitEnrollSelectionModalIsOpen, useQle } from '../../enrollment.context';
import { BenefitEventType, benefitsCategories } from '../..';
import QualifyingLifeEventDetails from '../qualifying-life-event-details';
import ConfirmEmptyModal from '../confirm-empty-documents-modal';
import AddressTable from '../address-table';
import ContactsTable from '../contacts-table';
import { EnrollmentSteps, EnrollmentWizard } from '../enrollment-wizard';

const HealthWrapper: React.FC = () => (
  <>
    <EnrollmentChanges categories={[benefitsCategories[0]]} enabledHeader={false} eventType="qle" />
  </>
);

const IncomeSecurityWrapper: React.FC = () => (
  <>
    <EnrollmentChanges categories={[benefitsCategories[1]]} enabledHeader={false} eventType="qle" />
  </>
);

const RetirmentLifestyleWrapper: React.FC = () => (
  <>
    <EnrollmentChanges categories={[benefitsCategories[2]]} enabledHeader={false} eventType="qle" />
  </>
);

const QualifyingLifeEvent: React.FC = () => {
  const qleSteps: EnrollmentSteps[] = [
    {
      title: 'Step 1:',
      subtitle: 'Address',
      content: <AddressTable />,
      available: true, // Always available
    },
    {
      title: 'Step 2:',
      subtitle: 'Contacts Information',
      content: <ContactsTable />,
      available: true, // Always available
    },
    {
      title: 'Step 3:',
      subtitle: 'Event Type & Details',
      content: <QualifyingLifeEventDetails />,
      available: true, // Always available
    },
    {
      title: 'Step 4:',
      subtitle: 'Health & Well-Being',
      content: <HealthWrapper />,
      available: true,
    },
    {
      title: 'Step 5:',
      subtitle: 'Income Security',
      content: <IncomeSecurityWrapper />,
      available: true,
    },
    {
      title: 'Step 6:',
      subtitle: 'Retirement & Lifestyle',
      content: <RetirmentLifestyleWrapper />,
      available: true,
    },
  ];

  const isOpen = useBenefitEnrollSelectionModalIsOpen();

  const { t } = useTranslation();
  const { getPersonalInfo, getCartSession } = useActions();
  const [confirmEmptySubmit, setConfirmEmptySubmit] = useState(false);

  const { setBenefitEnrollmentType } = useActions();

  const qle = useQle();

  const { loading } = useTypedSelector(state => state.benefits);
  const { cart, benefits, fetchingCartSession, enrollmentType } = useTypedSelector(state => state.benefits.data);
  const isEmpty = cart ? cart?.length <= 0 : true;

  const totalAddedToCart = cart
    ?.filter(benefit => benefit.action === 'ADD')
    ?.map(benefit => benefit.price)
    .reduce((acc, next) => Number(acc) + Number(next), 0) as unknown as 0;

  const navigate = useNavigate();

  useEffect(() => {
    setBenefitEnrollmentType(BenefitEventType.QLE);
    getPersonalInfo();
    getCartSession(BenefitEventType.QLE);
  }, []);

  const startReview = () => {
    const stateData = { event: enrollmentType, qle };

    navigate('/benefits/qle-review', { state: stateData });
  };

  const validateEmptySubmit = () => {
    if (enrollmentType === 'qle') {
      if (!qle?.files?.length || qle?.description?.trim() === '') {
        setConfirmEmptySubmit(true);
        return;
      }
    }
    startReview();
  };

  return (
    <Container>
      {(loading || fetchingCartSession) && <FullScreenLoading />}
      <Header>
        <HeaderItemLeft>
          <HeaderTitle>{t('benefits.qualifyingLifeEvent.title')}</HeaderTitle>
          <InfoIconContainer>
            <RelativeContainer id="tooltip">
              <TooltipText>
                A qualifying life event is a change in your life that may make you eligible for a Special Enrollment
                Period to enroll in benefits. Examples of qualifying life events are moving to a new state, change in
                employment status and changes in your family size (for example, if you marry, divorce, or have a baby).
              </TooltipText>
            </RelativeContainer>
            <InfoIcon src={InfoIconImg} />
          </InfoIconContainer>
        </HeaderItemLeft>
        <HeaderItemRight>
          <CancelButton onClick={() => navigate('/benefits', { replace: true })}>
            {t('global.form.cancel')}
          </CancelButton>
        </HeaderItemRight>
      </Header>
      <Content>
        <LeftGridContent>
          <EnrollmentWizard
            steps={qleSteps}
            submit={validateEmptySubmit}
            reviewEnabled={qle?.isEventInEligiblePeriod}
          />
          {isOpen && <EnrollSelectionModal eventType={BenefitEventType.QLE} />}
        </LeftGridContent>
        <RightGridContent>
          <CartTabs
            firstTabTitle="Active"
            FirstTabIcon={BenefitsAvailableIcon}
            secondTabTitle="Cart"
            SecondTabIcon={BenefitsCartIcon}
            FirstTabContent={() => (
              <ScrollableContainer>
                {benefits.map((benefit, index) => (
                  <AvailableBenefitsCard
                    // eslint-disable-next-line react/no-array-index-key
                    key={index}
                    benefitId={benefit.benefitId}
                    imgURL={benefit.imgURL}
                    title={benefit.benefitName}
                    subtitle={
                      benefit.dependentsDescription
                        ? benefit.dependentsDescription
                        : benefit.optionDescription || benefit.benefitOptionId
                    }
                    fee={monetaryUSDFormat(benefit.fixedAmount || benefit.employeeCost)}
                    date={benefit.benefitEnrollmentEnd}
                    editMode={false}
                    deleteMode={false}
                  />
                ))}
              </ScrollableContainer>
            )}
            SecondTabContent={() => (
              <>
                {isEmpty ? (
                  <ScrollableContainerEmpty>
                    <img src={BenefitsCart} />
                    <h3 style={{ margin: 0 }}>{t('benefits.qualifyingLifeEvent.emptyCart.line1')}</h3>
                    <p style={{ margin: 0 }}>{t('benefits.qualifyingLifeEvent.emptyCart.line2')}</p>
                    <p style={{ margin: 0 }}>{t('benefits.qualifyingLifeEvent.emptyCart.line3')}</p>
                  </ScrollableContainerEmpty>
                ) : (
                  <CartContainer>
                    <ScrollableContainer>
                      {cart?.map((benefit, index) => (
                        <AvailableBenefitsCard
                          // eslint-disable-next-line react/no-array-index-key
                          key={index}
                          type={benefit.type}
                          benefitId={benefit.benefitId}
                          imgURL={benefit.imgURL}
                          title={benefit.planDescription}
                          subtitle={
                            benefit.dependentsDescription ? benefit.dependentsDescription : benefit.optionDescription
                          }
                          fee={monetaryUSDFormat(benefit.price)}
                          date={benefit.expiration}
                          editMode={benefit.costCalculationMethod?.toLowerCase() !== 'free'}
                          deleteMode={benefit.costCalculationMethod?.toLowerCase() !== 'free'}
                          mandatory={false}
                          event="qle"
                        />
                      ))}
                    </ScrollableContainer>
                    <CartFooter>
                      <CartFooterText>
                        {t('benefits.newHire.totalOnCart')}: {monetaryUSDFormat(totalAddedToCart ?? 0)}
                      </CartFooterText>
                    </CartFooter>
                  </CartContainer>
                )}
              </>
            )}
          />

          <ConfirmEmptyModal isOpen={confirmEmptySubmit} setConfirmEmptySubmit={setConfirmEmptySubmit} />
        </RightGridContent>
      </Content>
    </Container>
  );
};

const QualifyingLifeEventStoreWrapper: React.FC = () => (
  <StoreContextProvider>
    <QualifyingLifeEvent />
  </StoreContextProvider>
);
export default QualifyingLifeEventStoreWrapper;
